/**
 * 图片工具：用 webpack require.context 统一解析 @/assets/img 下的图片
 * 用法：img('gen/hero-home.jpg')
 */
const ctx = require.context('../assets/img', true, /\.(png|jpe?g|webp|svg)$/)

export function img(path) {
  if (!path) return ''
  try {
    return ctx('./' + String(path).replace(/^\.?\//, ''))
  } catch (e) {
    // 图片缺失时不阻塞渲染
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[assets] 图片不存在：', path)
    }
    return ''
  }
}

export default img
